import { render, staticRenderFns } from "./Page.vue?vue&type=template&id=7b553ba4"
import script from "./Page.vue?vue&type=script&lang=ts"
export * from "./Page.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)


    import installComponents from "!F:/TFSAgents/TFS02-Build-01/_work/61/s/VetQuest.Backend/VetQuest.Web/client-app/node_modules/bootstrap-vue-loader/lib/runtime/installComponents.js"
    import {BSpinner, BCol, BRow, BContainer} from 'bootstrap-vue'
    installComponents(component, {BSpinner, BCol, BRow, BContainer})
    

export default component.exports